var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_3933)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 17.5,
    r: 14.5,
    fill: "#06B7A2",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 17.5,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9158 21.8483C15.9158 23.3886 14.6779 24.6362 13.1495 24.6362C11.6211 24.6362 10.3832 23.3886 10.3832 21.8483M28.6063 21.1514C28.9867 22.6429 28.0911 24.1622 26.6111 24.5421C25.1311 24.9254 23.6235 24.0229 23.2466 22.5314C23.1325 22.0783 23.1325 21.6009 23.2466 21.1479",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4485 10H22.8317C23.212 10 24.2148 10.4182 24.2148 11.3939V17.7363C24.2148 18.8514 23.212 21.3953 20.0308 21.3953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2148 17.6666H26.2895C29.6437 17.6666 29.7474 21.1514 29.7474 21.1514H21.6213M13.8411 16.9696C11.1681 16.9696 9 19.1546 9 21.8483H20.0653C20.0653 19.1546 17.8972 16.9696 15.2242 16.9696H13.8411Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9437 11.7424V13.8333M16.5728 14.1818H9C9.34579 16.3075 11.386 16.9696 13.8065 16.9696H15.1896C16.2685 17.008 17.3439 16.8059 18.3363 16.3772C19.4083 15.7848 19.512 14.1818 16.5728 14.1818Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_3933",
    x: 0,
    y: 0,
    width: 39,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_3933"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_3933",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverMarker);
export default __webpack_public_path__ + "static/media/DriverMarker.9cbf2150d89af84169960a09afba8bbb.svg";
export { ForwardRef as ReactComponent };